"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @category Guard
 * @returns `true` if `typeof value` is "boolean"
 * @example
 * ```typescript
 *   if(isBoolean(value)) return !value;
 * ```
 */
const isBoolean = ((value) => {
    return typeof value === "boolean";
});
exports.default = isBoolean;
